// Resolve a stored file URL for display.
// - Absolute URLs (Cloudinary, https://...) are returned as-is.
// - Legacy relative paths (/api/uploads/...) are prefixed with the backend URL.
export const fileUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};
